module.exports = __webpack_public_path__ + "img/logoWhite.94a2b468.svg";